var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":{
		lat: -34.87836125518865,
		lng: 138.6848756220065,
	},"zoom":14,"map-type-id":"roadmap","options":{
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		disableDefaultUi: false,
		styles: [{ stylers: [{ saturation: -100 }] }],
	}}},_vm._l((_vm.marker),function(mark,index){return _c('gmap-custom-marker',{key:index,attrs:{"marker":mark}},[_c('img',{attrs:{"src":_vm.marker_icon,"height":"50"}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib?{}!./scripts/vue/GoogleMap.vue?vue&type=template&id=1e24b8b3&scoped=true&
// module id = 331
// module chunks = 0